module.exports = __webpack_public_path__ + "img/03-B10.6369dc5c.png";